module.exports = __webpack_public_path__ + "img/loading.7ea91eaa.gif";